import { useEffect, useState } from "react";

// Card slot geometry — matches Tailwind w-[260px] lg:w-[300px] + gap-4 (16px).
// Returned as a constant from a media-query listener so the virtualizer can
// compute scroll offsets without DOM measuring on every frame.
export const SLOT_MOBILE = 260 + 16;
export const SLOT_DESKTOP = 300 + 16;

export const useSlotWidth = () => {
  const [slot, setSlot] = useState(() =>
    typeof window !== "undefined" &&
    window.matchMedia("(min-width: 1024px)").matches
      ? SLOT_DESKTOP
      : SLOT_MOBILE
  );
  useEffect(() => {
    const mq = window.matchMedia("(min-width: 1024px)");
    const onChange = () => setSlot(mq.matches ? SLOT_DESKTOP : SLOT_MOBILE);
    mq.addEventListener?.("change", onChange);
    return () => mq.removeEventListener?.("change", onChange);
  }, []);
  return slot;
};
